import { useCallback, useState } from "react";

const useRequests = () => {
  const [data, setData] = useState<any>({});
  const [error, setError] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [code, setStatusCode] = useState<number>();

  const baseUrl = process.env.REACT_APP_API_URL;

  const buildUrl = useCallback(
    (url: string): string => {
      if (url.startsWith("/")) return `${baseUrl}${url}`;
      if (url.startsWith("http")) return url;
      return `${baseUrl}/${url}`;
    },
    [baseUrl],
  );

  const request = useCallback(
    async (method: string, url: string, body?: any) => {
      setLoading(true);
      const headers: Record<string, string> = {
        "Content-Type": "application/json",
      };

      let reqBody: string | URLSearchParams | undefined;
      if (body instanceof URLSearchParams) {
        headers["Content-Type"] = "application/x-www-form-urlencoded";
        reqBody = body;
      } else if (body !== undefined && body !== null) {
        reqBody = JSON.stringify(body);
      }

      try {
        const response = await fetch(buildUrl(url), {
          method,
          headers,
          credentials: "include",
          body: reqBody,
        });

        setStatusCode(response.status);

        if (response.status === 204) {
          setData(null);
          return { data: null, status: response.status };
        }

        const responseData: any = await response.json();
        setData(responseData);
        return { data: responseData, status: response.status };
      } catch (err: any) {
        setError(err);
        return { data: null, status: 0 };
      } finally {
        setLoading(false);
      }
    },
    [buildUrl],
  );

  const get = useCallback((url: string) => request("GET", url), [request]);

  const post = useCallback(
    (url: string, body?: any, json: any = null) => {
      if (json !== null) return request("POST", url, json);
      return request("POST", url, body);
    },
    [request],
  );

  const patch = useCallback(
    (url: string, body: any) => request("PATCH", url, body),
    [request],
  );

  const del = useCallback((url: string) => request("DELETE", url), [request]);

  return { data, error, loading, code, get, post, patch, del };
};

export default useRequests;
